<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="success" class="ml-3">
        Novo Processo de Pagamento
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Novo processo de pagamento</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="limpar" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <!-- <v-alert
          type="error"
          v-if="!reports.length > 0 && !administrativeReports.length > 0"
        >
          <v-row>
            <v-col
              >Não exitem relatórios para criar um processo de pagamento</v-col
            >
          </v-row>
        </v-alert> -->
        <v-row>
          <v-col>
            <ComboboxContratoByUser
              :filter="payload"
              :user="user.usuarioId"
              @onChange="loadContrato"
              :hint="'Selecione um contrato (caso possua)'"
            ></ComboboxContratoByUser>
          </v-col>
        </v-row>

        <v-row v-if="payload.contratos.numContrato">
          <v-col>
            <v-expansion-panels
              multiple
              class="contract-expansion-panels"
              color="primary"
            >
              <v-expansion-panel
                class="contract-expansion-panel"
                color="primary"
              >
                <v-expansion-panel-header
                  class="contract-panel-header"
                  color="primary"
                >
                  <div class="d-flex align-center">
                    <div class="icon-wrapper mr-3">
                      <v-icon color="white" size="20"
                        >mdi-file-document-outline</v-icon
                      >
                    </div>
                    <span class="panel-title">Informações do Contrato</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="contract-panel-content">
                  <ContractInfoCard
                    :contract-data="payload.contratos"
                    subtitle="Informações detalhadas do contrato"
                    :max-description-length="200"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="verTipoSolucaoProcessoPagamento">
            <ComboboxTipoSolucao
              :filter="payload"
              :label="'Tipo de Produto'"
              @onChange="loadTipo"
              :disabled="!contrato || !contrato.contratoId"
              :hint="'Selecione o tipo de produto para filtrar os relatórios disponíveis'"
            ></ComboboxTipoSolucao>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              label="Número da entrega"
              name="numero"
              type="number"
              required
              :readonly="true"
              hide-details="auto"
              v-model="payload.numero"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Total de entregas"
              name="total"
              type="number"
              required
              :readonly="true"
              hide-details="auto"
              v-model="payload.contratos.qtdEntregasPrevistas"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="contrato && contrato.contratoId">
          <v-col>
            <v-text-field
              label="Ínicio do contrato"
              name="iniContrato"
              type="text"
              v-mask="'##/##/####'"
              disabled
              v-model="contrato.inicioString"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Fim do contrato"
              name="fimContrato"
              type="text"
              v-mask="'##/##/####'"
              disabled
              v-model="contrato.fimString"
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              label="Período de Realização (dd/mm/yyyy - dd/mm/yyyy)"
              name="realizacao"
              type="text"
              v-mask="'##/##/#### - ##/##/####'"
              required
              hide-details="auto"
              v-model="payload.periodoRealizacao"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h2>Execução do trabalho: {{ payload.horas }} h</h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h2>
              Relatórios disponíveis para abertura de processo de pagamento
            </h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="reports"
              v-model="selectedPayments"
              item-key="relatorioId"
              class="elevation-1"
              hide-default-footer
              disable-pagination
              :show-select="true"
            >
              <template slot="no-data">
                <span> Nenhum relatório retornado </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <template
          v-if="
            !config.ocultarRelatorioAdministrativos &&
            !groupsConfig.ocultarRelatorioAdministrativos
          "
        >
          <v-row>
            <v-col>
              <h2>
                Relatórios administrativos disponíveis para abertura de processo
                de pagamento
              </h2>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-data-table
                :headers="headersAdministrativeReport"
                :items="administrativeReports"
                v-model="selectedAdministrativePayments"
                item-key="relatorioAdministrativoId"
                class="elevation-1"
                hide-default-footer
                disable-pagination
                :show-select="true"
              >
                <template slot="no-data">
                  <span> Nenhum relatório administrativo retornado </span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="limpar">Fechar</v-btn>
        <v-btn color="info" outlined text @click="createPaymentProcess()"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { reportAPI } from "@/modules/report";
import { administrativeReportAPI } from "@/modules/administrative-report";
import { mapActions, mapGetters } from "vuex";
import { paymentReportManagementAPI } from "@/modules/payment-management";
import ComboboxContratoByUser from "@/modules/contratos/components/ComboboxByUser.vue";
import moment from "moment";
import { cityTaskAPI } from "@/modules/city/API/CityTaskAPI";
import ContractInfoCard from "@/components/ContractInfoCard.vue";
import ComboboxTipoSolucao from "@/modules/tipoSolucao/components/Combobox.vue";
export default {
  name: "AppModalInsertPayment",

  components: {
    ComboboxContratoByUser,
    ContractInfoCard,
    ComboboxTipoSolucao,
  },
  data() {
    return {
      dialog: false,
      reports: [],
      headers: [
        {
          text: "#",
          value: "relatorioId",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Município",
          value: "municipio.nome",
        },
        {
          text: "Criador",
          value: "usuario.nome",
        },
        {
          text: "Horas",
          value: "horasTarefas",
        },
      ],
      selectedPayments: [],
      payload: {
        relatorios: [],
        arquivos: [],
        arquivosEnviados: [],
        horas: 0,
        contratos: {},
        periodoRealizacao: "",
        numero: null,
        total: null,
        solucaoTipoId: null,
      },
      headersFiles: [
        {
          text: "Nome",
          value: "name",
        },
        {
          text: "Formato",
          value: "type",
        },
        {
          text: "Ações",
        },
      ],
      contrato: {},
      obrigatorio: (v) => !!v || "Campo Obrigatório",

      headersAdministrativeReport: [
        {
          text: "#",
          value: "relatorioAdministrativoId",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Município",
          value: "municipio.nome",
        },
        {
          text: "Criador",
          value: "usuario.nome",
        },
        {
          text: "Horas",
          value: "horas",
        },
      ],
      administrativeReports: [],
      selectedAdministrativePayments: [],
    };
  },
  computed: {
    ...mapGetters(["isGov", "user", "config", "groupsConfig", "isFullAdmin"]),
    verTipoSolucaoProcessoPagamento() {
      return (
        this.isFullAdmin ||
        (this.config.verTipoSolucaoProcessoPagamento &&
          this.groupsConfig.verTipoSolucaoProcessoPagamento)
      );
    },
  },
  mounted() {
    if (this.isGov) {
      this.headersAdministrativeReport = [
        {
          text: "#",
          value: "relatorioAdministrativoId",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Projeto",
          value: "municipio.nome",
        },
        {
          text: "Criador",
          value: "usuario.nome",
        },
        {
          text: "Horas",
          value: "horas",
        },
      ];

      this.headers = [
        {
          text: "#",
          value: "relatorioId",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Projeto",
          value: "municipio.nome",
        },
        {
          text: "Criador",
          value: "usuario.nome",
        },
        {
          text: "Horas",
          value: "horasUtilizadasString",
        },
      ];
    }
  },
  created() {
    // this.getReports();
    //this.getAdministrativeReports();
  },
  methods: {
    ...mapActions(["setLoading"]),
    isValidDate(d, m, y) {
      const date = new Date(y, m - 1, d);
      return (
        date.getFullYear() === parseInt(y) &&
        date.getMonth() === m - 1 &&
        date.getDate() === parseInt(d)
      );
    },
    periodoValido(input) {
      const regex = /^(\d{2})\/(\d{2})\/(\d{4}) - (\d{2})\/(\d{2})\/(\d{4})$/;
      const match = input.match(regex);

      if (!match) return "Periodo inválido";

      const [_, d1, m1, y1, d2, m2, y2] = match.map(Number);

      if (!this.isValidDate(d1, m1, y1) || !this.isValidDate(d2, m2, y2))
        return "Periodo inválido";

      const date1 = new Date(y1, m1 - 1, d1);
      const date2 = new Date(y2, m2 - 1, d2);

      if (date2 < date1)
        return "O período final não pode ser menor que o inicial";

      if (this.contrato && this.contrato.inicio && this.contrato.fim) {
        const inicioContrato = new Date(this.contrato.inicio);
        const fimContrato = new Date(this.contrato.fim);

        if (date1 < inicioContrato || date2 > fimContrato) {
          return "O período de Realização deve estar entre o início e o fim do contrato";
        }
      }

      if (this.payload.ultimoPeriodo) {
        const matchPeriodo = this.payload.ultimoPeriodo.match(regex);

        if (!matchPeriodo) return;

        const [_, d1p, m1p, y1p, d2p, m2p, y2p] = matchPeriodo.map(Number);

        const date2Periodo = new Date(y2p, m2p - 1, d2p);
        if (date1 < date2Periodo) {
          return `Favor criar um novo processo de pagamento com o período inicial maior que o último período do processo de pagamento anterior (${this.payload.ultimoPeriodo}).  `;
        }
      }

      return;
    },

    getReports(e, tipoSolucaoId) {
      this.setLoading(true);

      reportAPI
        .getByUser(this.$route.params.id, e, tipoSolucaoId ? tipoSolucaoId : 0)
        .then((resp) => {
          this.reports = resp.data;

          this.reports = this.reports.map((item) => {
            if (item.horasUtilizadasString.indexOf(":") > -1) {
              item.horasUtilizadasString = item.horasUtilizadasString.substring(
                1,
                2
              );
            }
            item.horasTarefas = parseInt(item.horasUtilizadasString);
            return item;
          });

          this.setLoading(false);
        })
        .catch((resp) => {
          console.error("Erro ao obter relatórios", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatórios");
        });
    },

    async createPaymentProcess() {
      this.payload.codigoContratacao = this.payload.contratos.numContrato;
      this.payload.contratoId = this.payload.contratos.contratoId;

      this.payload.total = this.payload.contratos.qtdEntregasPrevistas;
      if (
        this.selectedPayments.length === 0 &&
        this.selectedAdministrativePayments.length === 0
      ) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem relatórios!"
        );
      } else if (!this.payload.codigoContratacao) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem código de contratação!"
        );
      } else if (!this.payload.periodoRealizacao) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem período de realização!"
        );
      } else if (
        this.payload.periodoRealizacao &&
        this.periodoValido(this.payload.periodoRealizacao)
      ) {
        this.$notification.error(
          this.periodoValido(this.payload.periodoRealizacao)
        );
      } else if (!this.payload.numero) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem colocar o número do relatório!"
        );
      } else if (!this.payload.total) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem o total de relatórios!"
        );
      } else if (
        this.verTipoSolucaoProcessoPagamento &&
        !this.payload.solucaoTipoId
      ) {
        this.$notification.error(
          "Não é possível abrir um processo de pagamento sem o tipo!"
        );
      } else {
        this.setLoading(true);
        const { data: horas } = await cityTaskAPI.testaHoras(
          this.payload.contratos.contratoId
        );

        this.setLoading(false);
        let erro = false;
        if (horas) {
          const verificarEntregas =
            horas.qtdEntregasPrevistas > horas.qtdEntregas;
          if (!verificarEntregas) {
            this.$notification.error(
              "Não é possível gerar um novo processo de pagamento pois foi atingido o limite de entregas do contrato"
            );
            erro = true;
          }
        }

        if (!erro) {
          this.setLoading(true);

          let formData = new FormData();

          if (this.payload.arquivos.length > 0) {
            for (let i = 0; i < this.payload.arquivos.length; i++) {
              formData.append("arquivos", this.payload.arquivos[i]);
            }
          }

          formData.append(
            "relatoriosString",
            JSON.stringify(this.selectedPayments)
          );
          formData.append(
            "relatoriosAdministrativosString",
            JSON.stringify(this.selectedAdministrativePayments)
          );
          formData.append("contratoId", this.payload.contratoId);

          formData.append("codigoContratacao", this.payload.codigoContratacao);
          formData.append("periodoRealizacao", this.payload.periodoRealizacao);
          formData.append("horas", this.payload.horas);
          formData.append("numero", this.payload.numero);

          formData.append("solucoesTipoId", this.payload.solucaoTipoId || "");

          formData.append("total", this.payload.total);

          paymentReportManagementAPI
            .create(formData)
            .then((resp) => {
              this.limpar();
              this.$emit("onAddPayment");
              this.setLoading(false);
            })
            .catch((resp) => {
              this.setLoading(false);
              this.$notification.error("Erro ao inserir processo de pagamento");
            });
        }
      }
    },
    loadFiles() {
      if (this.payload.arquivosEnviados.length > 0) {
        this.payload.arquivosEnviados.forEach((arquivo) => {
          this.payload.arquivos.push(arquivo);
        });
      }
    },
    removeFile(file) {
      this.payload.arquivos = this.payload.arquivos.filter(
        (item) => item !== file
      );
    },
    limpar() {
      this.dialog = false;
      this.payload = {
        relatorios: [],
        arquivos: [],
        arquivosEnviados: [],
        horas: 0,
        contratos: {},
        periodoRealizacao: "",
        numero: null,
        total: null,
      };
      this.selectedPayments = [];
      this.selectedAdministrativePayments = [];
      this.contrato = {};
      this.reports = [];
      this.administrativeReports = [];
    },
    getNumeroRelatorio(e, tipoSolucaoId) {
      this.setLoading(true);
      paymentReportManagementAPI
        .getNumeroRelatorio(
          this.$route.params.id,
          e,
          tipoSolucaoId ? tipoSolucaoId : 0
        )
        .then((resp) => {
          this.payload.numero = resp.data ? resp.data.quantidadeAtual : 1;
          this.payload.ultimoPeriodo = resp.data
            ? resp.data.ultimoPeriodo
            : null;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatórios administrativos");
        });
    },
    getAdministrativeReports(e) {
      this.setLoading(true);

      administrativeReportAPI
        .getByUser(this.$route.params.id, e)
        .then((resp) => {
          this.administrativeReports = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatórios administrativos");
        });
    },
    loadTipo() {
      this.payload.solucaoTipoId = this.payload.solucaoTipoId;
      if (this.verTipoSolucaoProcessoPagamento) {
        this.getReports(this.contrato.contratoId, this.payload.solucaoTipoId);
        this.getNumeroRelatorio(
          this.contrato.contratoId,
          this.payload.solucaoTipoId
        );
      }
    },
    loadContrato(e) {
      if (!e) {
        this.contrato = {};
        this.selectedPayments = [];
        this.selectedAdministrativePayments = [];
        return;
      }

      let contratoid = e.contratoId;
      this.contrato = e;
      this.payload.contratos = e;
      this.contrato.inicioString = moment(e.inicio).format("DD/MM/YYYY");
      this.contrato.fimString = moment(e.fim).format("DD/MM/YYYY");
      this.selectedPayments = [];
      this.selectedAdministrativePayments = [];
      if (contratoid) {
        if (!this.verTipoSolucaoProcessoPagamento) {
          this.getReports(contratoid, null);
          this.getNumeroRelatorio(contratoid);
        } else {
          this.payload.solucaoTipoId = null;
          this.reports = [];
        }

        this.getAdministrativeReports(contratoid);
      }
    },
  },
  watch: {
    selectedPayments: function (newValue) {
      this.payload.horas = 0;
      newValue.forEach((relatorio) => {
        this.payload.horas += relatorio.horasTarefas;
      });
      this.selectedAdministrativePayments.forEach((relatorio) => {
        this.payload.horas += relatorio.horas;
      });
    },
    selectedAdministrativePayments: function (newValue) {
      this.payload.horas = 0;
      newValue.forEach((relatorio) => {
        this.payload.horas += relatorio.horas;
      });
      this.selectedPayments.forEach((relatorio) => {
        this.payload.horas += relatorio.horasTarefas;
      });
    },
  },
};
</script>
